// Module
var code = "<branch-terms kind=\"'deliveryMethods'\"></branch-terms>\n";
// Exports
module.exports = code;